/* ==========================================================================
   Pop-up conseil parfum (Grossiste Elite)
   Deux modes : « Guidez-moi » (5 questions) et « J'ai une marque en tête ».
   Aucune dépendance. Les données sont chargées à la première ouverture.
   ========================================================================== */
(function () {
  'use strict';

  var racine = document.getElementById('gequiz');
  if (!racine) return;

  var URL_DATA = racine.dataset.source;
  var CLE_PROFIL = 'gequiz.profil.v1';

  var D = null;              // données chargées
  var IDX = {};              // clé famille -> index dans le vecteur f
  var etat = { ecran: 'accueil', pas: 0, rep: {}, pile: [] };

  /* ── Utilitaires ──────────────────────────────────────────────────────── */
  var $ = function (s) { return racine.querySelector(s); };
  var el = function (t, c, h) {
    var n = document.createElement(t);
    if (c) n.className = c;
    if (h != null) n.innerHTML = h;
    return n;
  };
  var esc = function (s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  };
  var sansAccent = function (s) {
    return String(s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '');
  };
  var prix = function (v) {
    return v.toFixed(2).replace('.', ',').replace(/,00$/, '') + ' €';
  };
  var lienProduit = function (p) { return D.boutique + p.h; };
  var imageDe = function (p) { return p.i ? (/^https?:/.test(p.i) ? p.i : D.cdn + p.i) : ''; };

  /* -- Suivi d'usage (Google Sheet via Apps Script) ------------------------
     Inerte tant que data-suivi est vide. Rien de nominatif n'est envoye :
     l'evenement, les choix du quiz, et un identifiant de session tire au
     hasard. Voir Theme/SUIVI-google-sheet.md. */
  var URL_SUIVI = racine.dataset.suivi || '';

  var sessionId = function () {
    try {
      var k = 'gequiz.sid', v = sessionStorage.getItem(k);
      if (!v) {
        v = Date.now().toString(36) + Math.random().toString(36).slice(2, 8);
        sessionStorage.setItem(k, v);
      }
      return v;
    } catch (e) { return ''; }          // navigation privee
  };

  function suivre(ev, extra) {
    if (!URL_SUIVI) return;
    try {
      var p = { ev: ev, sid: sessionId(), t: Date.now() };
      if (extra) for (var k in extra) p[k] = extra[k];
      var corps = JSON.stringify(p);
      // sendBeacon survit au depart de la page : sans lui, le ping « produit »
      // serait annule par la navigation vers la fiche
      if (navigator.sendBeacon) navigator.sendBeacon(URL_SUIVI, corps);
      else fetch(URL_SUIVI, {
        method: 'POST', mode: 'no-cors', keepalive: true,
        headers: { 'Content-Type': 'text/plain;charset=UTF-8' }, body: corps
      });
    } catch (e) { /* le suivi ne doit jamais casser le quiz */ }
  }

  /* ── Logos des maisons ────────────────────────────────────────────────── */
  var BASE_ASSETS = racine.dataset.assets || '';

  // maisons pour lesquelles  assets/marque-<slug>.png  existe
  var LOGOS = ('amouage arabian-oud chanel creed dior dolce-gabbana giorgio-armani ' +
    'givenchy guerlain jean-paul-gaultier kayali kilian-paris lancome lattafa ' +
    'louis-vuitton maison-crivelli maison-francis-kurkdjian mugler ' +
    'parfums-de-marly prada rabanne tiziana-terenzi tom-ford xerjoff ' +
    'yves-saint-laurent').split(' ');

  // maisons sans logo propre qui empruntent celui de leur maison mère
  var ALIAS = { 'emporio-armani': 'giorgio-armani', 'armani-prive': 'giorgio-armani' };

  var slug = function (s) {
    return sansAccent(s).replace(/&/g, ' ')
      .replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
  };

  // « Xerjoff (Casamorati) » n'a pas de logo : on essaie la maison mère à
  // gauche de la parenthèse, puis celle entre parenthèses. « Asdaaf (Lattafa) »
  // porte la sienne dans l'autre sens.
  var marqueDe = function (maison) {
    var vide = { url: '', variante: '' };
    if (!BASE_ASSETS) return vide;
    var nom = String(maison || '');
    var propre = slug(nom);
    var par = nom.match(/\(([^)]+)\)/);
    var pistes = [propre];
    if (par) {
      pistes.push(slug(nom.replace(/\s*\([^)]*\)/, '')));
      pistes.push(slug(par[1]));
    }
    for (var i = 0; i < pistes.length; i++) {
      var c = ALIAS[pistes[i]] || pistes[i];
      if (LOGOS.indexOf(c) > -1) {
        return {
          url: BASE_ASSETS + 'marque-' + c + '.png',
          // logo emprunté à la maison mère : on nomme la déclinaison, sinon
          // Casamorati et Xerjoff donnent deux tuiles identiques côte à côte
          variante: c === propre ? '' : (par ? par[1] : nom)
        };
      }
    }
    return vide;
  };

  // vignette cliquable d'une maison ; repli sur le nom si le fichier manque
  var vignetteMaison = function (nom, marque, auClic) {
    var b = el('button', 'gequiz__marque');
    b.type = 'button';
    b.title = nom;
    var n = D.maisons[nom] ? D.maisons[nom].length : 0;
    b.setAttribute('aria-label', nom + (n ? ', ' + n + ' parfum' + (n > 1 ? 's' : '') : ''));

    var img = el('img');
    img.src = marque.url;
    img.alt = marque.variante ? '' : nom;
    img.loading = 'lazy';
    img.decoding = 'async';
    img.addEventListener('error', function () {
      b.classList.add('gequiz__marque--txt');
      b.textContent = nom;
    });
    b.appendChild(img);

    if (marque.variante) {
      b.appendChild(el('span', 'gequiz__marque-var', esc(marque.variante)));
    }
    b.addEventListener('click', auClic);
    return b;
  };

  /* ── Questions ────────────────────────────────────────────────────────── */
  var QUESTIONS = [
    {
      cle: 'genre',
      surtitre: 'Question 1 sur 5',
      titre: 'Ce parfum, c’est pour qui ?',
      aide: 'Cela nous aide à cadrer la sélection, sans rien exclure de définitif.',
      options: [
        { v: 'f', emoji: '💃', lab: 'Pour une femme' },
        { v: 'h', emoji: '🕴️', lab: 'Pour un homme' },
        { v: 'u', emoji: '🤝', lab: 'Mixte, peu importe' }
      ]
    },
    {
      cle: 'univers',
      multi: 2,
      surtitre: 'Question 2 sur 5',
      titre: 'Quel univers vous attire ?',
      aide: 'Choisissez-en un, ou deux si vous hésitez. C’est la question qui compte le plus.',
      options: null // rempli depuis les données
    },
    {
      cle: 'presence',
      surtitre: 'Question 3 sur 5',
      titre: 'Quelle présence recherchez-vous ?',
      aide: 'Un parfum discret se sent de près ; un parfum puissant laisse une trace derrière vous.',
      large: true,
      options: [
        { v: 'douce', emoji: '🤍', lab: 'Discrète', sub: 'collée à la peau, sur la pointe des pieds' },
        { v: 'equilibre', emoji: '⚖️', lab: 'Équilibrée', sub: 'se remarque sans envahir, pour tous les jours' },
        { v: 'forte', emoji: '🔥', lab: 'Puissante', sub: 'un vrai sillage, qui reste dans la pièce' }
      ]
    },
    {
      cle: 'occasion',
      surtitre: 'Question 4 sur 5',
      titre: 'Vous le porterez quand ?',
      aide: null,
      options: [
        { v: 'jour', emoji: '☀️', lab: 'Tous les jours', sub: 'bureau, courses, quotidien' },
        { v: 'soir', emoji: '🌙', lab: 'Sorties & soirées' },
        { v: 'speciale', emoji: '✨', lab: 'Occasions spéciales', sub: 'fêtes, mariages' },
        { v: 'tout', emoji: '🔀', lab: 'Un peu de tout' }
      ]
    },
    {
      cle: 'budget',
      surtitre: 'Question 5 sur 5',
      titre: 'Et côté budget ?',
      aide: 'Nous restons souples : si rien ne colle exactement, nous élargissons.',
      options: [
        { v: 'a', emoji: '🪙', lab: 'Moins de 10 €' },
        { v: 'b', emoji: '💶', lab: 'Entre 10 et 20 €' },
        { v: 'c', emoji: '💳', lab: 'Entre 20 et 30 €' },
        { v: 'x', emoji: '🤷', lab: 'Peu importe' }
      ]
    }
  ];

  var BUDGETS = { a: [0, 10], b: [10, 20], c: [20, 30] };

  /* ── Moteur de score ──────────────────────────────────────────────────── */
  // Aucun critère n'exclut : tout est pondéré, donc il y a toujours un résultat.
  function score(p, r) {
    var s = 0, i;

    // 1. Univers olfactif : le signal dominant
    var u = r.univers || [];
    var poidsUniv = u.length > 1 ? 38 : 62;
    for (i = 0; i < u.length; i++) s += (p.f[IDX[u[i]]] / 100) * poidsUniv;

    // 2. Genre
    if (r.genre && r.genre !== 'x') {
      if (p.g === r.genre) s += 12;
      else if (p.g === 'u') s += 6;
      else s -= 11;
    } else if (p.g === 'u') s += 3;

    // 3. Présence
    var f = p.f;
    if (r.presence === 'douce') {
      s += (f[IDX.musque] / 100) * 14 + (f[IDX.frais] / 100) * 8;
      s -= (f[IDX.oriental] / 100) * 11 + (f[IDX.epice] / 100) * 11;
      if (p.x) s -= 5;
    } else if (r.presence === 'forte') {
      s += (f[IDX.oriental] / 100) * 12 + (f[IDX.epice] / 100) * 10 + (f[IDX.boise] / 100) * 7;
      s -= (f[IDX.frais] / 100) * 7;
      if (p.x) s += 8;
    } else if (r.presence === 'equilibre') {
      s += (p.o & 1) ? 8 : 0;
    }

    // 4. Occasion (bit 1 = tous les jours, bit 2 = occasion spéciale)
    if (r.occasion === 'jour') s += (p.o & 1) ? 12 : -6;
    else if (r.occasion === 'soir' || r.occasion === 'speciale') s += (p.o & 2) ? 12 : -6;

    // 5. Budget : pénalité proportionnelle à l'écart, jamais éliminatoire
    var b = BUDGETS[r.budget];
    if (b) {
      if (p.p >= b[0] && p.p <= b[1]) s += 15;
      else {
        var ecart = p.p < b[0] ? b[0] - p.p : p.p - b[1];
        s -= Math.min(24, ecart * 1.8);
      }
    }

    // 6. Léger bonus aux parfums (vs brumes/coffrets) : c'est le cœur de gamme
    if (p.s === 'p') s += 3;

    // 7. Bonus aux références dont l'inspiration est documentée : elles se
    //    présentent mieux (badge « Dans l'esprit de ») et rassurent à l'achat.
    if (p.io) s += 2;

    // 8. Départage. Les vecteurs de familles saturent souvent à 100, ce qui
    //    crée beaucoup d'égalités parfaites ; sans ce bruit déterministe le
    //    podium serait toujours occupé par les titres en début d'alphabet.
    s += empreinte(p.h);

    return s;
  }

  // Petit nombre stable dans [0, 3[, dérivé du handle. Déterministe : le même
  // client qui refait le quiz retrouve les mêmes résultats.
  var cacheEmpreinte = {};
  function empreinte(h) {
    if (cacheEmpreinte[h] !== undefined) return cacheEmpreinte[h];
    var x = 0;
    for (var i = 0; i < h.length; i++) x = (x * 31 + h.charCodeAt(i)) >>> 0;
    return (cacheEmpreinte[h] = (x % 1000) / 333.4);
  }

  // Deux références du même parfum (50 / 100 ml, flacon / brume / coffret) ne
  // doivent pas occuper deux places du podium : on ne garde que la meilleure.
  var PREFIXES = /^(?:brume|coffret|spray|musc|huile|d[ée]odorant|d[ée]sodorisant|diffuseur|encens|cr[èe]me(?:\s+corps)?|parfum(?:\s+voiture)?)\s+/i;
  function groupeDe(p) {
    var base = p.t.split(/\s+[-–]\s+/)[0].replace(PREFIXES, '');
    // on retire aussi les mentions de format et de concentration
    base = base.replace(/\b\d+\s*(?:ml|g)\b/gi, '')
      .replace(/\b(?:all over spray|eau de parfum|extrait de parfum|eau de toilette)\b/gi, '');
    return sansAccent(base).replace(/[^a-z0-9]+/g, '') + '|' + sansAccent(p.m);
  }

  function recommander(r, combien) {
    var notes = D.produits.map(function (p) { return { p: p, s: score(p, r) }; });
    notes.sort(function (a, b) { return b.s - a.s; });
    var vus = {}, sortie = [];
    for (var i = 0; i < notes.length && sortie.length < combien; i++) {
      var g = groupeDe(notes[i].p);
      if (vus[g]) continue;
      vus[g] = 1;
      sortie.push(notes[i]);
    }
    return sortie;
  }

  /* ── Rendu : cartes produit ───────────────────────────────────────────── */
  function carte(p, rang) {
    var a = el('a', 'gequiz__carte' + (rang === 1 ? ' gequiz__carte--1' : ''));
    a.href = lienProduit(p);
    a.rel = 'noopener';
    a.addEventListener('click', function () {
      suivre('produit', { produit: p.h, prix: p.p, maison: p.im || '', inspi: p.io || '' });
    });

    var img = imageDe(p);
    a.appendChild(el('img', 'gequiz__vign'));
    var vign = a.firstChild;
    vign.src = img;
    vign.alt = '';
    vign.loading = 'lazy';
    vign.width = 92;
    vign.height = 92;

    var esprit = p.io
      ? '<span class="gequiz__esprit">Dans l’esprit de ' + esc(p.io) + (p.im ? ' · ' + esc(p.im) : '') + '</span>'
      : '';

    a.appendChild(el('div', 'gequiz__carte-txt',
      (rang === 1 ? '<span class="gequiz__medaille">Notre recommandation</span>' : '') +
      '<p class="gequiz__carte-tit">' + esc(p.t) + '</p>' +
      (p.n && p.n.length ? '<p class="gequiz__carte-notes">' + esc(p.n.join(' · ')) + '</p>' : '') +
      '<span class="gequiz__carte-bas"><span class="gequiz__prix">' + prix(p.p) + '</span>' + esprit + '</span>'
    ));
    return a;
  }

  /* ── Écrans et navigation ─────────────────────────────────────────────── */
  // afficher() ne fait que basculer l'écran visible.
  // naviguer() empile en plus la vue courante, pour que le bouton retour marche.
  function afficher(nom) {
    etat.ecran = nom;
    var ecrans = racine.querySelectorAll('.gequiz__ecran');
    for (var i = 0; i < ecrans.length; i++)
      ecrans[i].dataset.actif = ecrans[i].dataset.ecran === nom ? '1' : '0';
    $('.gequiz__retour').hidden = etat.pile.length === 0;
    $('.gequiz__corps').scrollTop = 0;
    jauge(nom === 'question' ? (etat.pas + 1) / QUESTIONS.length : nom === 'resultat' ? 1 : 0);
  }

  function naviguer(nom) {
    etat.pile.push({ ecran: etat.ecran, pas: etat.pas });
    afficher(nom);
  }

  function jauge(part) { $('.gequiz__jauge span').style.width = Math.round(part * 100) + '%'; }

  function rendreQuestion() {
    var q = QUESTIONS[etat.pas];
    var box = $('[data-ecran="question"]');
    box.innerHTML = '';
    box.appendChild(el('p', 'gequiz__surtitre', esc(q.surtitre)));
    box.appendChild(el('h2', 'gequiz__question', esc(q.titre)));
    if (q.aide) box.appendChild(el('p', 'gequiz__aide', esc(q.aide)));

    var opts = q.options || D.familles.map(function (f) {
      return { v: f.k, emoji: f.emoji, lab: f.label, sub: f.sous };
    });

    var grille = el('div', 'gequiz__choix' + (q.large ? ' gequiz__choix--large' : ''));
    var choisis = q.multi ? (etat.rep[q.cle] || []).slice() : [];

    opts.forEach(function (o) {
      var b = el('button', 'gequiz__opt');
      b.type = 'button';
      b.setAttribute('aria-pressed', choisis.indexOf(o.v) > -1 ? 'true' : 'false');
      b.innerHTML =
        '<span class="gequiz__opt-emoji">' + o.emoji + '</span>' +
        '<span class="gequiz__opt-txt"><span class="gequiz__opt-lab">' + esc(o.lab) + '</span>' +
        (o.sub ? '<span class="gequiz__opt-sub">' + esc(o.sub) + '</span>' : '') + '</span>';

      b.addEventListener('click', function () {
        if (!q.multi) {
          etat.rep[q.cle] = o.v;
          avancer();
          return;
        }
        var i = choisis.indexOf(o.v);
        if (i > -1) choisis.splice(i, 1);
        else {
          if (choisis.length >= q.multi) choisis.shift();
          choisis.push(o.v);
        }
        etat.rep[q.cle] = choisis;
        var tous = grille.querySelectorAll('.gequiz__opt');
        for (var j = 0; j < tous.length; j++)
          tous[j].setAttribute('aria-pressed', choisis.indexOf(opts[j].v) > -1 ? 'true' : 'false');
        valider.disabled = choisis.length === 0;
      });
      grille.appendChild(b);
    });
    box.appendChild(grille);

    var valider;
    if (q.multi) {
      var actions = el('div', 'gequiz__actions');
      valider = el('button', 'gequiz__btn gequiz__btn--or', 'Continuer');
      valider.type = 'button';
      valider.disabled = choisis.length === 0;
      valider.addEventListener('click', avancer);
      actions.appendChild(valider);
      box.appendChild(actions);
    }
  }

  function avancer() {
    etat.pile.push({ ecran: 'question', pas: etat.pas });
    if (etat.pas < QUESTIONS.length - 1) {
      etat.pas++;
      rendreQuestion();
      afficher('question');
    } else {
      try { localStorage.setItem(CLE_PROFIL, JSON.stringify(etat.rep)); } catch (e) { /* mode privé */ }
      rendreResultat();
      afficher('resultat');
    }
  }

  function rendreResultat() {
    var box = $('[data-ecran="resultat"]');
    var top = recommander(etat.rep, 12);
    var trois = top.slice(0, 3);

    suivre('complete', {
      genre: etat.rep.genre || '',
      univers: (etat.rep.univers || []).join('+'),
      presence: etat.rep.presence || '',
      occasion: etat.rep.occasion || '',
      budget: etat.rep.budget || '',
      n: top.length
    });

    box.innerHTML = '';
    box.appendChild(el('p', 'gequiz__surtitre', 'Votre sélection'));
    box.appendChild(el('h2', 'gequiz__question', 'Voici ce qui vous ressemble'));

    var univ = (etat.rep.univers || []).map(function (k) {
      var f = D.familles.filter(function (x) { return x.k === k; })[0];
      return f ? f.label.toLowerCase() : k;
    });
    box.appendChild(el('p', 'gequiz__aide',
      'Trois parfums choisis parmi ' + D.produits.length + ' références en stock' +
      (univ.length ? ', côté ' + esc(univ.join(' et ')) + '.' : '.')));

    var liste = el('div', 'gequiz__liste');
    trois.forEach(function (r, i) { liste.appendChild(carte(r.p, i + 1)); });
    box.appendChild(liste);

    var actions = el('div', 'gequiz__actions');
    if (top.length > 3) {
      var plus = el('button', 'gequiz__btn gequiz__btn--fant', 'Voir ' + (top.length - 3) + ' autres correspondances');
      plus.type = 'button';
      plus.addEventListener('click', function () {
        plus.remove();
        top.slice(3).forEach(function (r) { liste.appendChild(carte(r.p, 0)); });
      });
      actions.appendChild(plus);
    }
    var refaire = el('button', 'gequiz__btn gequiz__btn--fant', 'Recommencer');
    refaire.type = 'button';
    refaire.addEventListener('click', reinitialiser);
    actions.appendChild(refaire);
    box.appendChild(actions);
  }

  /* ── Mode « J'ai une marque en tête » ─────────────────────────────────── */
  function rendreRecherche() {
    var box = $('[data-ecran="recherche"]');
    box.innerHTML = '';
    box.appendChild(el('p', 'gequiz__surtitre', 'Mode inspiration'));
    box.appendChild(el('h2', 'gequiz__question', 'Quel parfum aimez-vous déjà ?'));
    box.appendChild(el('p', 'gequiz__aide',
      'Tapez le nom d’un parfum ou d’une maison, nous vous montrons nos alternatives.'));

    var champ = el('div', 'gequiz__rech');
    var input = el('input');
    input.type = 'search';
    input.placeholder = 'Baccarat Rouge, Tom Ford, Vanilla 28…';
    input.autocomplete = 'off';
    input.setAttribute('aria-label', 'Rechercher un parfum ou une maison');
    champ.appendChild(input);
    box.appendChild(champ);

    var sugg = el('ul', 'gequiz__sugg');
    box.appendChild(sugg);

    var titreM = el('p', 'gequiz__aide', 'Ou partez d’une maison :');
    titreM.style.margin = '18px 0 0';
    box.appendChild(titreM);

    var avecLogo = [], sansLogo = [];
    Object.keys(D.maisons).slice(0, 28).forEach(function (m) {
      var mq = marqueDe(m);
      if (mq.url) avecLogo.push({ nom: m, mq: mq }); else sansLogo.push({ nom: m });
    });

    if (avecLogo.length) {
      var grilleM = el('div', 'gequiz__marques');
      avecLogo.forEach(function (o) {
        grilleM.appendChild(vignetteMaison(o.nom, o.mq, function () { rendreMaison(o.nom); }));
      });
      box.appendChild(grilleM);
    }

    if (sansLogo.length) {
      var puces = el('div', 'gequiz__maisons');
      sansLogo.forEach(function (o) {
        var b = el('button', 'gequiz__puce', esc(o.nom));
        b.type = 'button';
        b.addEventListener('click', function () { rendreMaison(o.nom); });
        puces.appendChild(b);
      });
      box.appendChild(puces);
    }

    input.addEventListener('input', function () {
      var q = sansAccent(input.value.trim());
      sugg.innerHTML = '';
      if (q.length < 2) return;

      var res = [];
      Object.keys(D.maisons).forEach(function (m) {
        if (sansAccent(m).indexOf(q) > -1) res.push({ type: 'maison', nom: m, n: D.maisons[m].length });
      });
      Object.keys(D.inspirations).forEach(function (o) {
        if (sansAccent(o).indexOf(q) > -1) res.push({ type: 'parfum', nom: o, n: D.inspirations[o].r.length });
      });
      res.sort(function (a, b) { return b.n - a.n; });

      res.slice(0, 12).forEach(function (r) {
        var li = el('li');
        var b = el('button', null,
          '<span>' + esc(r.nom) + (r.type === 'maison' ? ' <em>· maison</em>' : '') + '</span>' +
          '<em>' + r.n + (r.type === 'maison' ? ' parfums' : ' alternative' + (r.n > 1 ? 's' : '')) + '</em>');
        b.type = 'button';
        b.addEventListener('click', function () {
          if (r.type === 'maison') rendreMaison(r.nom);
          else rendreAlternatives(r.nom);
        });
        li.appendChild(b);
        sugg.appendChild(li);
      });

      if (!res.length) {
        var li0 = el('li');
        var b0 = el('button', null, '<span>Aucune correspondance, répondez plutôt à 5 questions</span>');
        b0.type = 'button';
        b0.addEventListener('click', demarrerQuestions);
        li0.appendChild(b0);
        sugg.appendChild(li0);
      }
    });

    naviguer('recherche');
    setTimeout(function () { input.focus(); }, 60);
  }

  function rendreMaison(maison) {
    var box = $('[data-ecran="detail"]');
    box.innerHTML = '';
    suivre('maison', { maison: maison });
    box.appendChild(el('p', 'gequiz__surtitre', 'Maison'));

    var urlLogo = marqueDe(maison).url;
    if (urlLogo) {
      var enTete = el('img', 'gequiz__maison-logo');
      enTete.src = urlLogo;
      enTete.alt = maison;
      enTete.decoding = 'async';
      enTete.addEventListener('error', function () { enTete.remove(); });
      box.appendChild(enTete);
    }
    box.appendChild(el('h2', 'gequiz__question', esc(maison)));

    var originaux = D.maisons[maison] || [];
    box.appendChild(el('p', 'gequiz__aide',
      originaux.length + ' parfum' + (originaux.length > 1 ? 's' : '') + ' de cette maison ' +
      (originaux.length > 1 ? 'ont' : 'a') + ' une alternative chez nous.'));

    var grille = el('div', 'gequiz__choix');
    originaux.forEach(function (o) {
      var n = D.inspirations[o].r.length;
      var b = el('button', 'gequiz__opt');
      b.type = 'button';
      b.innerHTML = '<span class="gequiz__opt-txt"><span class="gequiz__opt-lab">' + esc(o) + '</span>' +
        '<span class="gequiz__opt-sub">' + n + ' alternative' + (n > 1 ? 's' : '') + '</span></span>';
      b.addEventListener('click', function () { rendreAlternatives(o); });
      grille.appendChild(b);
    });
    box.appendChild(grille);
    naviguer('detail');
  }

  function rendreAlternatives(original) {
    var info = D.inspirations[original];
    if (!info) return;
    suivre('inspi', { inspi: original, maison: info.m || '', n: info.r.length });
    var index = {};
    D.produits.forEach(function (p) { index[p.h] = p; });
    var liste = info.r.map(function (h) { return index[h]; }).filter(Boolean);

    // écran distinct de « detail » : sinon le retour depuis les alternatives
    // écraserait la liste de la maison dont on vient
    var box = $('[data-ecran="alternatives"]');
    box.innerHTML = '';
    box.appendChild(el('p', 'gequiz__surtitre', 'Dans l’esprit de'));
    box.appendChild(el('h2', 'gequiz__question', esc(original)));
    box.appendChild(el('p', 'gequiz__aide',
      (info.m ? esc(info.m) + '. ' : '') + liste.length + ' alternative' + (liste.length > 1 ? 's' : '') +
      ' en stock, de ' + prix(liste[0].p) + ' à ' + prix(liste[liste.length - 1].p) + '.'));

    var grille = el('div', 'gequiz__liste');
    liste.forEach(function (p, i) { grille.appendChild(carte(p, i === 0 ? 1 : 0)); });
    box.appendChild(grille);

    var actions = el('div', 'gequiz__actions');
    var autre = el('button', 'gequiz__btn gequiz__btn--fant', 'Chercher un autre parfum');
    autre.type = 'button';
    autre.addEventListener('click', rendreRecherche);
    actions.appendChild(autre);
    box.appendChild(actions);

    naviguer('alternatives');
  }

  /* ── Parcours ─────────────────────────────────────────────────────────── */
  function demarrerQuestions() {
    etat.pas = 0;
    etat.rep = {};
    rendreQuestion();
    naviguer('question');
  }

  function reinitialiser() {
    etat.pile = [];
    etat.rep = {};
    etat.pas = 0;
    try { localStorage.removeItem(CLE_PROFIL); } catch (e) { /* mode privé */ }
    afficher('accueil');
  }

  function retour() {
    var vue = etat.pile.pop();
    if (!vue) return;
    etat.pas = vue.pas;
    // seul l'écran de questions dépend de l'étape : il faut le reconstruire
    if (vue.ecran === 'question') rendreQuestion();
    afficher(vue.ecran);
  }

  /* ── Ouverture / fermeture ────────────────────────────────────────────── */
  var focusAvant = null;

  function ouvrir() {
    focusAvant = document.activeElement;
    suivre('open');
    racine.dataset.ouvert = '1';
    document.body.style.overflow = 'hidden';
    charger();
  }

  function fermer() {
    racine.dataset.ouvert = '0';
    document.body.style.overflow = '';
    if (focusAvant && focusAvant.focus) focusAvant.focus();
  }

  function charger() {
    if (D) return;
    var box = $('[data-ecran="accueil"]');
    fetch(URL_DATA)
      .then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.json();
      })
      .then(function (d) {
        D = d;
        d.familles.forEach(function (f, i) { IDX[f.k] = i; });
        $('.gequiz__charge').hidden = true;
        box.hidden = false;
      })
      .catch(function () {
        $('.gequiz__charge').innerHTML =
          'Le conseiller n’a pas pu se charger.<br>Réessayez dans un instant.';
      });
  }

  /* ── Câblage ──────────────────────────────────────────────────────────── */
  $('.gequiz__fermer').addEventListener('click', fermer);
  $('.gequiz__retour').addEventListener('click', retour);
  $('.gequiz__voile').addEventListener('click', fermer);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && racine.dataset.ouvert === '1') fermer();
  });

  $('[data-mode="questions"]').addEventListener('click', function () {
    suivre('mode', { mode: 'questions' });
    demarrerQuestions();
  });
  $('[data-mode="inspiration"]').addEventListener('click', function () {
    suivre('mode', { mode: 'inspiration' });
    rendreRecherche();
  });

  var declencheurs = document.querySelectorAll('[data-gequiz-ouvrir]');
  for (var i = 0; i < declencheurs.length; i++)
    declencheurs[i].addEventListener('click', ouvrir);

  // Ouverture automatique, une seule fois par session, si le thème le demande
  if (racine.dataset.auto === '1') {
    var vu = 'gequiz.vu';
    try {
      if (!sessionStorage.getItem(vu)) {
        setTimeout(function () {
          if (racine.dataset.ouvert !== '1') { sessionStorage.setItem(vu, '1'); ouvrir(); }
        }, parseInt(racine.dataset.delai || '15000', 10));
      }
    } catch (e) { /* mode privé */ }
  }

  // _score et _recommander sont exposés pour permettre de tester le moteur
  // hors navigateur (voir Theme/test-moteur.mjs).
  window.GEQuiz = {
    ouvrir: ouvrir, fermer: fermer,
    _score: score, _recommander: recommander,
    _injecter: function (d) { D = d; d.familles.forEach(function (f, i) { IDX[f.k] = i; }); }
  };
})();
